import { useCallback, useRef } from 'react'

import { Proceeding } from '../../common/proceedingTypes'
import { useAppSelector } from '../../redux/hooks'
import { getProceedingKey } from './proceedingDetailHelpers'

export interface UseProceedingWindowResult {
  openWindow: () => void
  isOpen: boolean
}

export const useProceedingWindow = (
  proceeding?: Proceeding,
  onClose?: () => void
): UseProceedingWindowResult => {
  const crmId = useAppSelector(state => state.myProfile.regestaCrm)
  const windowRef = useRef<Window | null>(null)
  const intervalRef = useRef<number>()

  const checkWindowStatus = useCallback(() => {
    if (windowRef.current?.closed) {
      windowRef.current = null
      onClose?.()
    }
    if (!windowRef.current) {
      clearInterval(intervalRef.current)
    }
  }, [onClose])

  const sendMessageToWindow = useCallback(
    (target: Window) => {
      if (!crmId) return

      setTimeout(() => {
        target.postMessage(
          'regestaCrm:' + crmId,
          'https://nahlizenidokn.cuzk.gov.cz'
        )
      }, 1500)
    },
    [crmId]
  )

  const openWindow = useCallback(() => {
    if (!proceeding) return

    const key = getProceedingKey(proceeding)
    const url = `https://nahlizenidokn.cuzk.gov.cz/VyberRizeni.aspx?otevritRizeni=${key}&rr=true`

    const drawerWidth = Math.min(500, window.innerWidth * 0.75)
    const leftPosition = window.innerWidth - drawerWidth - 800

    windowRef.current = window.open(
      url,
      'oknorizeni',
      `width=800,height=${window.outerHeight},left=${leftPosition},top=0`
    )

    if (windowRef.current) {
      intervalRef.current = window.setInterval(checkWindowStatus, 500)
      sendMessageToWindow(windowRef.current)
    }
  }, [proceeding, checkWindowStatus, sendMessageToWindow])

  return {
    openWindow,
    isOpen: !!windowRef.current,
  }
}
